import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['select', 'dateRange', 'form']

  connect() {
    this.toggleDateRange()
  }

  change() {
    this.toggleDateRange()
    
    // Auto-submit if not custom range
    if (this.selectTarget.value !== 'custom') {
      this.formTarget.submit()
    }
  }

  toggleDateRange() {
    if (this.hasDateRangeTarget) {
      if (this.selectTarget.value === 'custom') {
        this.dateRangeTarget.classList.remove('hidden')
        this.dateRangeTarget.classList.add('flex')
      } else {
        this.dateRangeTarget.classList.add('hidden')
        this.dateRangeTarget.classList.remove('flex')
      }
    }
  }
}
